export interface IChatUserInfoData {
    displayName: string;
    useNftAsAvatar: boolean;
    usingCroppedImage: boolean;
    photoUrl: string | number;
    nftUrl: string;
    croppedImageUrl: string;
    shortId: number;
};

export const INIT_CHAT_USER_INFO_DATA: IChatUserInfoData = {
    displayName: '',
    useNftAsAvatar: false,
    usingCroppedImage: false,
    photoUrl: '',
    nftUrl: '',
    croppedImageUrl: '',
    shortId: 0,
};

export interface IChatUserInfosState {
    [index: string]: IChatUserInfoData;
};

export const INIT_CHAT_AVATARS_STATE =  {};
